import { createReducer } from './create';

const initialState = {
    start_time: null,
    product: null,
    event_url: null,
    is_toggled: false,
    selected_package: null,
    confirmed_package: null,
    confirmed_tickets: [],
    food: null,
    optional_hotel:
        window.cart_settings != null
            ? window.cart_settings.hotel_optional
            : window.NOJESRESOR_PRODUCT != null
                ? window.NOJESRESOR_PRODUCT.hotels.optional
                : false,
    without_hotel:
        window.cart_settings != null
            ? window.cart_settings.hotel_no
            : window.NOJESRESOR_PRODUCT != null
                ? window.NOJESRESOR_PRODUCT.hotels.without
                : false,
    confirmed_hotel: null,
    confirmed_hotel_range: null,
    selected_hotel_range: 0,
    selected_hotel_nights: 0,
    selected_hotel_roomtype: 0,
    dinner: null,
    require_dinner: false,
    confirmed_dinner: null,
    confirmed_food: null,
    giftcards: [],
    loading_cart: false,
    loading_empty_cart: false,

    create_cart_error: false,
    create_cart_error_code: null,
    create_cart_error_message: null,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: state => {
        return Object.assign({}, initialState, {
            loading_empty_cart: state.loading_empty_cart,
        });
    },
    ['APP/SOFT_CLEAR']: state => {
        return Object.assign({}, initialState, {
            loading_empty_cart: state.loading_empty_cart,
        });
    },
    ['APP/CLEAR_EVENT']: state => {
        return {
            ...initialState,
            loading_empty_cart: state.loading_empty_cart,
            giftcards: state.giftcards,
        };
    },
    ['PACKAGES/SELECT']: (state, payload) => {
        return Object.assign({}, state, {
            selected_package: payload.package,
        });
    },
    ['TICKETS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            product: NOJESRESOR_PRODUCT,
            event_url: document.location.href,
            confirmed_package: payload.confirmed_package,
            confirmed_tickets: payload.confirmed_tickets,
            food: payload.food,
            optional_hotel: NOJESRESOR_PRODUCT.hotels.optional,
            without_hotel: NOJESRESOR_PRODUCT.hotels.without,
            confirmed_hotel: null,
            confirmed_hotel_range: null,
            selected_hotel_roomtype: 0,
            dinner: null,
            confirmed_dinner: null,
            confirmed_food: null,
            loading_cart: false,
        });
    },
    ['HOTELS/DESELECT']: state => {
        return Object.assign({}, state, {
            confirmed_hotel: null,
            confirmed_hotel_range: null,
            selected_hotel_roomtype: 0,
            dinner: null,
            confirmed_dinner: null,
            loading_cart: false,
        });
    },
    ['HOTELS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_hotel: payload.confirmed_hotel,
            confirmed_hotel_range: payload.confirmed_hotel_range,
            selected_hotel_range: payload.selected_hotel_range,
            selected_hotel_nights: payload.selected_hotel_nights,
            selected_hotel_roomtype: payload.selected_hotel_roomtype,
            dinner: null,
            confirmed_dinner: null,
            loading_cart: false,
        });
    },
    ['DINNER/SHOW']: state => {
        return Object.assign({}, state, {
            require_dinner: true,
        });
    },
    ['DINNER/DESELECT']: state => {
        return Object.assign({}, state, {
            confirmed_dinner: null,
            dinner: null,
            require_dinner: false,
        });
    },
    ['DINNER/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_dinner: {
                id: payload.id,
                time: payload.time,
                meat: payload.meat,
                fish: payload.fish,
                veg: payload.veg,
            },
            dinner: payload.dinner,
            aliases: payload.aliases,
        });
    },
    ['FOOD/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_food: payload.food,
        });
    },
    ['GIFTCARD/ADD']: (state, payload) => {
        return {
            ...state,
            giftcards: [
                ...state.giftcards,
                {
                    id: payload.id,
                    image: payload.image,
                    to: payload.to,
                    from: payload.from,
                    value: payload.value,
                    greeting: payload.greeting,
                },
            ],
        };
    },
    ['GIFTCARD/REMOVE']: (state, {id}) => {
        const giftcards = state.giftcards.filter(giftcard => giftcard.id !==
            id);
        const newState = {
            giftcards,
        };

        if (giftcards.length === 0 && state.confirmed_tickets.length === 0) {
            newState.start_time = null;
        }

        return {...state, ...newState};
    },
    ['CART/CLEAR']: state => {
        return Object.assign({}, state, {
            loading_empty_cart: true,
        });
    },
    ['CART/CREATE']: state => {
        return Object.assign({}, state, {
            loading_cart: true,
        });
    },
    ['CART/CREATED']: state => {
        return Object.assign({}, state, {
            loading_cart: false,
        });
    },
    ['CART/START_TIMER']: state => {
        return {...state, start_time: new Date().getTime()};
    },
    ['CART/CREATE_ERROR']: (state, payload) => {
        return Object.assign({}, state, {
            loading_cart: false,
            create_cart_error_code: payload.code,
            create_cart_error_message: payload.message,
            create_cart_error: true,
        });
    },
    ['CART/CLEAR_EMPTY_CART_OVERLAY']: state => {
        return Object.assign({}, state, {
            loading_empty_cart: false,
        });
    },
    ['CART/SEND_TO_WORDPRESS_ERROR_CLEAR']: state => {
        return Object.assign({}, state, {
            loading_cart: false,
            create_cart_error: false,
        });
    },
    ['CART/TOGGLE']: state => {
        return Object.assign({}, state, {
            is_toggled: !state.is_toggled,
        });
    },
    ['CART/CLOSE']: state => {
        return Object.assign({}, state, {
            is_toggled: false,
        });
    },
    ['CART/OPEN']: state => {
        return Object.assign({}, state, {
            is_toggled: true,
        });
    },
});
